module.exports = __webpack_public_path__ + "static/Forvis-Mazars-logo-ea383db2e2594c3548d509aa3d86500d.png";